<template>
  <div>
    <label :for="inputID" class="form-label">{{ label }}</label>
    <select
      class="form-select"
      @change="update"
      :required="required"
      :id="inputID"
      v-model="selectedValue"
      :name="inputID"
      :disabled="isDisabled"
    >
      <option disabled value="">{{ defaultValue }}</option>
      <option v-for="value in values" :key="value" :value="value">
        {{ value }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const emit = defineEmits(["onUpdate"]);

const props = defineProps({
  values: {
    type: Array<string>,
  },
  defaultValue: {
    required: false,
    type: String || Number,
  },
  required: {
    required: false,
    type: Boolean,
  },
  label: {
    type: String,
  },
  inputID: {
    type: String,
  },
  isDisabled: {
    type: Boolean,
  },
});

function hasRealDefault(
  defaultValue: string | number | undefined | null,
): boolean {
  return (
    defaultValue !== undefined &&
    defaultValue !== null &&
    `${defaultValue}` !== ""
  );
}

// Use "" when there is no default so the empty placeholder option is selected
// and required validation fails until the user picks a real option.
const selectedValue = ref(
  hasRealDefault(props.defaultValue) ? props.defaultValue : "",
);

function update() {
  emit("onUpdate", props.inputID, selectedValue.value);
}

// Only seed parent answers when a real default selection exists
if (hasRealDefault(props.defaultValue)) {
  update();
}
</script>

<style scoped>
input {
  min-width: 300px;
}
</style>
